import { render } from "./MyOrders.vue?vue&type=template&id=76746558&scoped=true"
import script from "./MyOrders.vue?vue&type=script&lang=js"
export * from "./MyOrders.vue?vue&type=script&lang=js"

import "./MyOrders.vue?vue&type=style&index=0&id=76746558&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76746558"]])

export default __exports__